// src/pages/ReportsListPage.jsx
import { useEffect, useState } from "react";
import { fetchReports } from "../api/sowApi";
import { useNavigate } from "react-router-dom";
import "../styles/reports.css";

export default function ReportsListPage() {
  const [reports, setReports] = useState([]);
  const [filters, setFilters] = useState({
    account_name: "",
    opportunity_name: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const loadReports = async () => {
    setLoading(true);
    setError("");
    try {
      const cleanFilters = {};
      Object.entries(filters).forEach(([k, v]) => {
        if (v) cleanFilters[k] = v;
      });
      const data = await fetchReports(cleanFilters);
      setReports(data);
    } catch (err) {
      console.error(err);
      setError("Failed to load reports.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters((f) => ({ ...f, [name]: value }));
  };

  const onSearch = (e) => {
    e.preventDefault();
    loadReports();
  };

  return (
    <div className="reports-page">
      <header className="reports-header">
        <div>
          <h1>SOW Analysis Reports</h1>
          <p>Search and review previous SOW Analyzer outputs.</p>
        </div>
        <form className="reports-filters" onSubmit={onSearch}>
          <input
            name="account_name"
            placeholder="Account Name"
            value={filters.account_name}
            onChange={onChangeFilter}
          />
          <input
            name="opportunity_name"
            placeholder="Opportunity Name"
            value={filters.opportunity_name}
            onChange={onChangeFilter}
          />
          <button type="submit" disabled={loading}>
            {loading ? "Searching..." : "Search"}
          </button>
        </form>
      </header>

      {error && <div className="reports-error">{error}</div>}

      <section className="reports-list">
        <table className="reports-table">
          <thead>
            <tr>
              <th>Created</th>
              <th>Account</th>
              <th>Opportunity</th>
              <th>Stage</th>
              <th>Score</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {reports.map((r) => (
              <tr key={r.id}>
                <td>{new Date(r.created_at).toLocaleString()}</td>
                <td>{r.account_name}</td>
                <td>{r.opportunity_name}</td>
                <td>{r.stage}</td>
                <td>{Math.round(r.overall_score)}</td>
                <td>
                  <button
                    type="button"
                    onClick={() => navigate(`/reports/${r.id}`)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
            {reports.length === 0 && !loading && (
              <tr>
                <td colSpan="6" className="empty-cell">
                  No reports found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}
